import axios from "axios";
import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
function getDateRange(dateString) {
  // Parse the given date string
  const date = new Date(dateString);

  // Calculate the start date: date - 5 days - 1 year
  const startDate = new Date(date);
  startDate.setDate(startDate.getDate() - 5);
  startDate.setFullYear(startDate.getFullYear() - 1);

  // Calculate the end date: date - 5 days
  const endDate = new Date(date);
  endDate.setDate(endDate.getDate() - 5);

  // Format dates as YYYY-MM-DD strings
  const formatDate = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return { startDate: formatDate(startDate), endDate: formatDate(endDate) };
}

const CheckDimentions = ({ SIData, allQData }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (
      SIData?.dimensions?.eastWestMeasurmentInMeter &&
      SIData?.dimensions?.northSouthMeasurmentInMeter
    ) {
      let eastWestM = +SIData?.dimensions?.eastWestMeasurmentInMeter;
      let nortSouthM = +SIData?.dimensions?.northSouthMeasurmentInMeter;
      let bay = +allQData?.input_info?.bay_size;
      let span = +allQData?.input_info?.span_size;
      if (
        !(
          (eastWestM >= bay && nortSouthM >= span) ||
          (eastWestM >= span && nortSouthM >= bay)
        )
      ) {
        setShow(true);
      }
    }
  }, [SIData]);

  return show ? (
    <>
      <div
        style={{
          border: "3px solid red",
          marginTop: "10px",
          padding: "10px",
          backgroundColor: "#ffefea",
        }}
      >
        <h3 className="text-uppercase text-red">
          Attention: Dimension Mismatch
        </h3>
        <h4 className="mt-10">
          Your Site Inspection dimensions and Quotation dimensions do not match
          the required condition. Please update the quotation according to SI
          dimensions.
        </h4>
        <ul>
          <li>
            SI East-West Measurement (in meters) :{" "}
            {SIData?.dimensions?.eastWestMeasurmentInMeter}
          </li>
          <li>
            SI North-South Measurement (in meters) :{" "}
            {SIData?.dimensions?.northSouthMeasurmentInMeter}
          </li>
          <li>
            Quotation Bay Size (in meters) : {allQData?.input_info?.bay_size}
          </li>
          <li>
            Quotation Span Size (in meters) : {allQData?.input_info?.span_size}
          </li>
        </ul>
      </div>
      <div
        className="html2pdf__page-break"
        style={{
          pageBreakAfter: "always",
          display: "block",
          clear: "both",
        }}
      ></div>
    </>
  ) : (
    ""
  );
};

export default CheckDimentions;
